/**
 * Offensive-language screening for user-generated content (Supporter Wall).
 *
 * This is a prototype-only client-side pass. Any real production run MUST
 * screen server-side because a client filter can be bypassed by editing
 * runtime state.
 *
 * The list below is a starter — Ops can extend it and the server will own
 * the canonical version.
 *
 * TODO(backend): move the check to a server endpoint:
 *   POST /api/moderation/screen { text } -> { ok: bool, blocked: string[] }
 *   The server owns the canonical list and returns a redacted preview
 *   or a hard reject. Rate-limit per IP.
 */

// Starter list — intentionally conservative. Slurs deliberately omitted from
// this repo; Ops adds those directly on the server-side list.
const STARTER_BLOCKLIST = [
  // Insults directed at the student
  "stupid", "idiot", "moron", "dumb", "loser", "pathetic",
  // Aggression
  "kill", "die", "hate you", "shut up",
  // Sexual harassment
  "sexy", "hot body", "nudes",
  // Placeholder for slur-family additions (Ops-managed)
  "slur-example",
];

// Word-boundary regex per term so "assistant" doesn't false-match "ass", etc.
// Terms with spaces are matched as substrings.
const buildMatcher = (terms) => {
  const parts = terms.map((t) => {
    const escaped = t.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    // For multi-word terms, use substring match. For single words, word-boundary.
    return /\s/.test(t) ? escaped : `\\b${escaped}\\b`;
  });
  return new RegExp(`(${parts.join("|")})`, "gi");
};

const MATCHER = buildMatcher(STARTER_BLOCKLIST);

/**
 * Returns the array of matched blocked terms (empty = clean).
 */
export const screenMessage = (text = "") => {
  if (!text.trim()) return [];
  const hits = text.match(MATCHER) || [];
  // Dedupe + normalise casing for the caller's UI copy.
  return Array.from(new Set(hits.map((h) => h.toLowerCase())));
};

export const isClean = (text) => screenMessage(text).length === 0;
